
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-newsletter",
      function () {
        return require("private-next-pages/contact-newsletter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-newsletter"])
      });
    }
  